// G:\qkard\frontend\src\config\cdn.js
//
// Converts S3 photo URLs to CloudFront CDN URLs at read time.
// This is a safety net — most URLs should already be CDN URLs after migration,
// but anything stale (cached state, in-flight uploads, legacy items) gets
// rewritten transparently.
//
// Use:
//   import { toCdn } from "@/config/cdn";
//   <img src={toCdn(item.photo)} />

export const CDN_DOMAIN = "d1l7dbfnkyewoy.cloudfront.net";

const S3_HOSTS = [
  "qkard-media.s3.ap-south-1.amazonaws.com",
  "qkard-media.s3.amazonaws.com",
];

/**
 * Rewrite an S3 photo URL to use the CloudFront domain.
 * Non-S3 URLs (unsplash, data:, blob:, https://other) pass through unchanged.
 *
 * Examples:
 *   toCdn("https://qkard-media.s3.ap-south-1.amazonaws.com/items/abc.jpg")
 *     → "https://d1l7dbfnkyewoy.cloudfront.net/items/abc.jpg"
 *   toCdn("https://images.unsplash.com/photo-123") → unchanged
 *   toCdn(null) → null
 */
export function toCdn(url) {
  if (!url || typeof url !== "string") return url;
  if (!url.startsWith("http")) return url;

  try {
    const u = new URL(url);
    if (S3_HOSTS.includes(u.host)) {
      return `https://${CDN_DOMAIN}${u.pathname}${u.search}`;
    }
    // Path-style: https://s3.ap-south-1.amazonaws.com/qkard-media/...
    if (u.host.startsWith("s3.") && u.pathname.startsWith("/qkard-media/")) {
      const stripped = u.pathname.replace(/^\/qkard-media/, "");
      return `https://${CDN_DOMAIN}${stripped}${u.search}`;
    }
  } catch {
    // Malformed URL — return as-is.
  }
  return url;
}

/**
 * Map an array of URLs through toCdn(). Useful for items.photos.
 */
export function toCdnAll(urls) {
  if (!Array.isArray(urls)) return urls;
  return urls.map(toCdn);
}
